import { useMemo } from "react";
import { usePermissions } from "../../hooks/usePermissions";

export const useHasProcessingAccess = () => {
  const { hasAccess } = usePermissions();

  const canViewProcessing: boolean = useMemo(
    () => hasAccess("Batches", "GetList"),
    [hasAccess]
  );

  const canBatchView: boolean = useMemo(
    () => hasAccess("Batches", "GetSingle"),
    [hasAccess]
  );

  const canPaymentView: boolean = useMemo(
    () => hasAccess("BatchPayments", "GetSingle"),
    [hasAccess]
  );

  return { canViewProcessing, canBatchView, canPaymentView };
};
